// Runtime config injected by the server (or the Vite dev server) as <meta name="w3send-config">.
// It carries no secrets: the dashboard origins we may talk to, the path we are served under and
// which CRM frames us (one build serves both hosts).

export type HostKind = 'w3chat' | 'chatwoot';

export interface RuntimeConfig {
  appKey: string;
  basePath: string;
  dashboardOrigins: string[];
  hostKind: HostKind;
  /** Temporary (SESSION_HANDOFF=on, Chatwoot host): conversation tab sign-in through the sidebar. */
  sessionHandoff: boolean;
}

function readConfig(): RuntimeConfig {
  const content = document.querySelector<HTMLMetaElement>('meta[name="w3send-config"]')?.content;
  if (!content)
    throw new Error('Missing <meta name="w3send-config">: the page was not served by the app server');
  const parsed = JSON.parse(content) as Partial<RuntimeConfig>;
  if (
    typeof parsed.appKey !== 'string' ||
    typeof parsed.basePath !== 'string' ||
    !Array.isArray(parsed.dashboardOrigins)
  ) {
    throw new Error('Invalid w3send-config');
  }
  return {
    appKey: parsed.appKey,
    basePath: parsed.basePath,
    dashboardOrigins: parsed.dashboardOrigins,
    hostKind: parsed.hostKind === 'chatwoot' ? 'chatwoot' : 'w3chat',
    sessionHandoff: parsed.hostKind === 'chatwoot' && parsed.sessionHandoff === true,
  };
}

export const config: RuntimeConfig = readConfig();
